export const PRICE_ORDER_SERVICE_ERROR = 'Backend system is down. Your actual pricing will be updated later.';
export const PRICE_ORDER_SERVICE_ERROR1 = 'Error occured while fetching priceorder';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const WARE_HOUSE_CODE_ERROR_MESSAGE = "Unable to retrive the location details";
export const WARE_HOUSE_CODE_DISPLAY_ERROR_MESSAGE = "6LM is not an active location";
export const WARE_HOUSE_CODE_DISPLAY_RETURN_ERROR_MESSAGE = "Return location 6LM is not active";




// WEBPACK FOOTER //
// ./src/App/components/common/messageConstants.js